module.exports = __webpack_public_path__ + "static/img/up-user-details-background.84295f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-profile/up-user-details-background.jpg
// module id = cKzk
// module chunks = 3